import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import I18n from 'utils/I18n';
import Cldr from 'utils/Cldr';

import styles from './index.scss';

export const I18nPrefix = 'strava.subscriptions.checkout.terms';

export class Terms extends React.Component {
  typeKey = () => {
    return this.props.isTrial ? 'trial' : 'organic';
  };

  durationKey = () => {
    return this.props.duration;
  };

  recurringPrice = () => {
    const { amount, currency, isStudentPromotion, billedToday } = this.props;
    if (isStudentPromotion) {
      return Cldr.formatCurrency(billedToday, currency);
    }
    return Cldr.formatCurrency(amount, currency);
  };

  render() {
    const { hideTerms } = this.props;

    if (hideTerms) {
      return '';
    }

    return (
      <div className={styles.termsContainer}>
        <p className={styles.terms}>
          {I18n.t(`${I18nPrefix}.${this.typeKey()}.${this.durationKey()}`, {
            price: this.recurringPrice()
          })}
        </p>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  duration: state.duration,
  isTrial: state.isTrial,
  currency: state.currency,
  amount: state.products[state.duration].recurringAmount,
  hideTerms: state.products.promotion.full,
  isStudentPromotion: state.isStudentPromotion,
  billedToday: state.products[state.duration].billedToday
});

Terms.propTypes = {
  isTrial: PropTypes.bool,
  hideTerms: PropTypes.bool,
  duration: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  isStudentPromotion: PropTypes.bool,
  billedToday: PropTypes.number
};

Terms.defaultProps = {
  isTrial: false,
  hideTerms: false,
  isStudentPromotion: false,
  billedToday: 0
};

export default connect(mapStateToProps)(Terms);
